/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
import {
  useRef, useEffect, useState, memo,
} from 'react';
import verifyReCaptchaApi from '@features/Authentication/services/verifyReCaptchaApi';
import ReCAPTCHA from 'react-google-recaptcha';

function ReCaptcha({
  setIsReCaptcha,
  setNoReCaptchaCheck,
  showMenuOption,
  setMenuOption,
  setLoadingLogin,
}) {
  const recaptchaRef = useRef();
  const [tokenVal, setTokenVal] = useState('');
  const currentScrollStyle = window.getComputedStyle(document.body, null).overflow;
  const initObserver = (topValueWindow) => {
    const recaptchaWindow = [
      ...document.getElementsByTagName('iframe'),
    ]?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))?.parentNode?.parentNode;
    const captchaContainer = [
      ...document.getElementsByTagName('iframe'),
    ]?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))?.parentNode;

    // Make sure it is defined (it was found in the doc) before we add the observer
    if (recaptchaWindow && tokenVal === '') {
      const observerCaptcha = new MutationObserver(() => {
        // ReCaptcha changes these 3 props when going invisible.
        // To solve this, we put an observer on the attributes and
        // check if one of these 3 properties changed from their
        // initial value.
        if (
          recaptchaWindow.style.visibility !== 'visible'
          || recaptchaWindow.style.opacity !== '1'
          || recaptchaWindow.style.top !== '179px'
          || recaptchaWindow.style.visibility === 'hidden'
        ) {
          // If changed, put back on default values.
          if (topValueWindow !== '' || topValueWindow !== undefined) {
            recaptchaWindow.style.top = topValueWindow;
          }
          if (showMenuOption) {
            document.body.style.overflow = 'auto';
          }
          recaptchaWindow.style.opacity = '1';
          recaptchaWindow.style.visibility = 'visible';
          captchaContainer.style.position = 'absolute';
          captchaContainer.style.top = '50%';
          captchaContainer.style.zIndex = 2000000000;
        }
      });
      observerCaptcha.observe(recaptchaWindow, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  };
  const detectReCaptchaChallengeAppearance = () => new Promise((resolve) => {
    const targetElement = document.body;

    const observerConfig = {
      childList: true,
      attributes: false,
      attributeOldValue: false,
      characterData: false,
      characterDataOldValue: false,
      subtree: false,
    };

    function DOMChangeCallbackFunction(mutationRecords) {
      mutationRecords.forEach((mutationRecord) => {
        if (mutationRecord.addedNodes.length) {
          const reCaptchaParentContainer = mutationRecord.addedNodes[0];
          const reCaptchaIframe = reCaptchaParentContainer.querySelectorAll('iframe[title*="recaptcha challenge expires in two minutes"]');
          if (reCaptchaIframe.length !== 0) {
            const reCaptchaChallengeOverlayDiv = reCaptchaParentContainer;
            if (reCaptchaChallengeOverlayDiv) {
              reCaptchaObserver.disconnect();
              resolve(reCaptchaChallengeOverlayDiv);
            }
          }
        }
      });
    }

    const reCaptchaObserver = new MutationObserver(DOMChangeCallbackFunction);
    reCaptchaObserver.observe(targetElement, observerConfig);
  });
  const detectParentContainer = () => new Promise((resolve) => {
    const recaptchaWindow = [
      ...document.getElementsByTagName('iframe'),
    ]?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))?.parentNode?.parentNode;
    if (recaptchaWindow) {
      const observerCaptcha = new MutationObserver(() => {
        if (
          recaptchaWindow.style.visibility !== 'visible'
          || recaptchaWindow.style.visibility === 'hidden'
          || recaptchaWindow.style.top !== '179px'
          || recaptchaWindow.style.opacity !== '1'
        ) {
          const topValuePx = window.getComputedStyle(recaptchaWindow, null).top;
          if (showMenuOption) {
            document.body.style.overflow = 'auto';
          }
          setMenuOption(false);
          setLoadingLogin(false); // To turn off the loading when puzzle appear.
          resolve(topValuePx);
          initObserver(topValuePx);
          observerCaptcha.disconnect();
        }
      });
      observerCaptcha.observe(recaptchaWindow, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  });

  detectReCaptchaChallengeAppearance().then((reCaptchaChallengeOverlayDiv) => {
    const reCaptchaChallengeClosureObserver = new MutationObserver(() => {
      if ((reCaptchaChallengeOverlayDiv.style.visibility === 'hidden')) {
        // TADA!! Do something here as the challenge was either closed
        // by hitting outside of an overlay div OR by pressing ESC key
        detectParentContainer().then((data) => {
          initObserver(data);
        });
        reCaptchaChallengeClosureObserver.disconnect();
      }
    });
    if (reCaptchaChallengeOverlayDiv) {
      reCaptchaChallengeClosureObserver.observe(reCaptchaChallengeOverlayDiv, {
        attributeFilter: ['style'],
      });
    }
    detectParentContainer().then((data) => {
      initObserver(data);
    });
  });
  const verifyReCaptcha = (token) => {
    verifyReCaptchaApi(token)
      .then((response) => {
        setTokenVal('');
        const recaptchaWindow = [
          ...document.getElementsByTagName('iframe'),
        ]?.find((x) => x.src.includes('google.com/recaptcha/api2/bframe'))?.parentNode?.parentNode;
        if (recaptchaWindow) {
          recaptchaWindow.remove();
        }
        if (response.data.data.success === false) {
          setNoReCaptchaCheck(true);
        }
      })
      .catch((error) => {
        setNoReCaptchaCheck(true);
        setTokenVal('');
        // eslint-disable-next-line no-restricted-syntax
        console.error(error);
      });
  };

  const onLoadReCaptchaExecute = async () => {
    console.log(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY);
    const token = await recaptchaRef.current.executeAsync(); // execute reCaptcha
    // verify token
    if (token) {
      // return the default scroll behavior of the document
      document.body.style.overflow = currentScrollStyle;
      setLoadingLogin(false); // turn off loading
      setIsReCaptcha(true);
      setNoReCaptchaCheck(false);
      if (showMenuOption) {
        setMenuOption(true);
      }
      setTokenVal(token);
      verifyReCaptcha(token);
    } else if (!token) {
      setLoadingLogin(false); // turn off loading
      setIsReCaptcha(true);
      setNoReCaptchaCheck(true);
    }
  };

  useEffect(() => {
    onLoadReCaptchaExecute();
  }, []);

  // eslint-disable-next-line no-unused-vars
  const onChange = (_value) => {
    recaptchaRef.current.reset(); // reset the reCaptcha widget
  };
  const onError = (error) => {
    // eslint-disable-next-line no-restricted-syntax
    console.error(error);
    setLoadingLogin(false); // turn off loading
    setIsReCaptcha(true);
    setNoReCaptchaCheck(true);
  };

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      size='invisible'
      // sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
      sitekey='6LdDjc8qAAAAACOQ8Nlf38c5avtkkBsuddzSvXeX'
      onChange={onChange}
      onErrored={onError}
    />
  );
}

export default memo(ReCaptcha);
